(function () {
    function initHomeFaq(accordionRoot) {
        if (accordionRoot.dataset.faqReady === '1') {
            return;
        }

        accordionRoot.dataset.faqReady = '1';

        const getItems = () =>
            Array.from(accordionRoot.querySelectorAll('.home-faq__item--interactive'));

        const closeItem = (item) => {
            const trigger = item.querySelector('.home-faq__trigger');
            const panel = item.querySelector('.home-faq__panel');

            item.classList.remove('is-open');

            if (trigger) {
                trigger.setAttribute('aria-expanded', 'false');
            }

            if (panel) {
                panel.hidden = true;
            }
        };

        const openItem = (item) => {
            const trigger = item.querySelector('.home-faq__trigger');
            const panel = item.querySelector('.home-faq__panel');

            item.classList.add('is-open');

            if (trigger) {
                trigger.setAttribute('aria-expanded', 'true');
            }

            if (panel) {
                panel.hidden = false;
            }
        };

        const syncItem = (item) => {
            const trigger = item.querySelector('.home-faq__trigger');
            const panel = item.querySelector('.home-faq__panel');

            if (!trigger || !panel) {
                return;
            }

            const isOpen = item.classList.contains('is-open');
            panel.hidden = !isOpen;
            trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        };

        getItems().forEach(syncItem);

        accordionRoot.addEventListener('click', (event) => {
            const trigger = event.target.closest('.home-faq__trigger');

            if (!trigger || trigger.disabled || !accordionRoot.contains(trigger)) {
                return;
            }

            const item = trigger.closest('.home-faq__item--interactive');

            if (!item) {
                return;
            }

            const isOpen = item.classList.contains('is-open');

            if (isOpen) {
                closeItem(item);
                return;
            }

            getItems().forEach(closeItem);
            openItem(item);
        });
    }

    function bootHomeFaq() {
        document.querySelectorAll('[data-home-faq]').forEach(initHomeFaq);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bootHomeFaq, { once: true });
    } else {
        bootHomeFaq();
    }
})();
